


































































import {Component, Vue} from 'vue-property-decorator';
import {mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';

@Component({
    computed: {
        ...mapState('planEdit', ['planEdit']),
    },
})
export default class PlanEditSettingsCard extends Vue {
    public planEdit!: PlanEditModel | null;
}
